export const DEFAULT_SCROLL_OBSERVER_ROOT_ID = '__DEFAULT_SCROLL_OBSERVER_ROOT_ID__';
